import React from 'react';
import { Check, ArrowUpRight } from 'lucide-react';
import { useContent } from '../../content';
import { useLang } from '../../i18n';

const Expertise = ({ onContact }) => {
  const { expertise } = useContent();
  const { t } = useLang();
  return (
    <div className="grid lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] gap-12 lg:gap-16 items-start">
      {/* Left */}
      <div>
        <div className="label-mono text-ember mb-6">[{expertise.index}] · {expertise.label}</div>
        <h2 className="font-display font-light text-white text-3xl md:text-4xl lg:text-5xl leading-[1.1] tracking-tight">
          {expertise.headingLead}
          <span className="text-ember">{expertise.headingAccent}</span>
        </h2>
        <p className="mt-8 text-white/70 font-body text-base leading-relaxed">{expertise.body}</p>

        {/* Industries */}
        <div className="mt-12">
          <div className="label-mono text-white/45 mb-5">[{expertise.industriesIndex}] · {expertise.industriesLabel}</div>
          <div className="flex flex-wrap gap-2.5">
            {expertise.industries.map((ind, i) => (
              <span
                key={ind}
                className="inline-flex items-center gap-2.5 rounded-full liquid-glass-chip px-4 py-2.5 text-white/85 font-body text-sm cursor-default"
              >
                <span className="label-mono text-ember">{String(i + 1).padStart(2, '0')}</span>
                {ind}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Right - capability list 2 cols */}
      <div>
        <div className="grid sm:grid-cols-2 gap-x-10">
          {expertise.capabilities.map((c) => (
            <div
              key={c}
              className="group flex items-center gap-3 py-4 border-b border-white/10 hover:border-ember/40 transition-colors"
            >
              <Check size={16} strokeWidth={2.5} className="text-ember shrink-0" />
              <span className="text-white/85 font-body text-[15px] group-hover:text-white transition-colors">{c}</span>
            </div>
          ))}
        </div>
        <div className="mt-10 flex items-center gap-3">
          <span className="label-mono text-white/45">{t('ui.needCapability')}</span>
          <button
            onClick={onContact}
            className="group inline-flex items-center gap-2 label-mono text-ember hover:text-ember-hover transition-colors"
          >
            {t('ui.talkEngineers')}
            <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Expertise;
